import type { Driver } from "@pulse/api/driverApi";
import type { Taxonomy } from "@pulse/api/taxonomyApi";
import { useSetLanguage } from "@/hooks/languageHooks";

const languageToTitleKey = {
    nb: "title_no",
    en: "title_en",
} as const;

export function useDriverTitle(): (driver: Driver) => string {
    const { currentLanguage } = useSetLanguage();
    const titleKey = languageToTitleKey[currentLanguage];

    return (driver) => driver[titleKey];
}

export function useTaxonomyTitle(): (taxonomy: Taxonomy) => string {
    const { currentLanguage } = useSetLanguage();
    const titleKey = languageToTitleKey[currentLanguage];

    return (taxonomy) => taxonomy[titleKey];
}
